import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useFiles } from 'publisher/store'
import { fileSelectors } from 'publisher/store/file/fileSelectors'
import React from 'react'
import { CommonWebsiteLogo } from 'src/shared/entities/website-logo'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
export interface WebsiteLogoProps {
  entity: WebsiteLogoInterface
}

export const WebsiteLogo = ({ entity }: WebsiteLogoProps) => {
  const fileId = entity.logoFileId
  const mobileLogoFileId =
    entity?.mobileLogoFileId === undefined ? fileId : entity?.mobileLogoFileId

  const file = useFiles(files => fileSelectors.getFile(files, fileId))
  const mobileFile = useFiles(files =>
    fileSelectors.getFile(files, mobileLogoFileId),
  )

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonWebsiteLogo
        {...entity}
        imageSrc={file?.path ?? ''}
        mobileImageSrc={
          mobileLogoFileId === null ? '' : (mobileFile?.path ?? '')
        }
      />
    </StyleWrapper>
  )
}
